import { useEffect } from 'react';

const COOKIEBOT_SCRIPT_ID = 'Cookiebot';
const COOKIEBOT_SCRIPT_SOURCE = 'https://consent.cookiebot.com/uc.js';

/**
 * Loads Cookiebot after hydration and avoids adding it more than once.
 *
 * Cookiebot injects its consent UI into the document body. Loading it in an
 * effect keeps that third-party DOM mutation out of the server-rendered tree
 * while React hydrates it.
 */
export function useCookiebot(cbid: string): void {
  useEffect(() => {
    if (document.getElementById(COOKIEBOT_SCRIPT_ID) !== null) {
      return;
    }

    const script = document.createElement('script');
    script.id = COOKIEBOT_SCRIPT_ID;
    script.src = COOKIEBOT_SCRIPT_SOURCE;
    script.dataset['cbid'] = cbid;
    script.type = 'text/javascript';
    script.async = true;
    document.head.append(script);
  }, [cbid]);
}
